<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap>
			<template #overlay>
				<div class="text-center">

					<p id="cancel-label">Generado Reporte...</p>
					<section>
						<b-progress :value="loadingPercent" variant="success" :striped="true" animated></b-progress>
					</section>
					<br>

					<b-button
						ref="cancel"
						variant="outline-danger"
						size="sm"
						aria-describedby="cancel-label"
						@click="forceStop = true"
						:disabled="forceStop"
					>
						Cancelar
					</b-button>
					<br>
					<small class="text-danger" v-if="forceStop">Esperando la siguiente iteración para detener el reporte</small>
				</div>
			</template>
		</b-overlay>
		<b-card>
			<b-row>
				<b-form-group
						label="Source:"
						size="sm"
						class="col-md-4"
						>
						<b-form-select v-model="filters.source" class="mb-3" size="sm">
							<b-form-select-option value="apiMozio">Cotizaciones Mozio</b-form-select-option>
							<!---<b-form-select-option value="bookingDotCom" >Cotizaciones Booking</b-form-select-option>-->
						</b-form-select>
					</b-form-group>
			</b-row>
			<b-row>
				<b-col cols="3">
					Fecha Creacion Desde
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.startDate"
						:max="maxDate"
					/>
				</b-col>
				<b-col cols="3">
					Hasta
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.endDate"
						:max="maxDate"
					/>
				</b-col>
				<b-col cols="3">
					Fecha servicio Desde
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.serviceStartDate"
					/>
				</b-col>
				<b-col cols="3">
					Hasta
					<b-form-datepicker
						reset-button
						today-button
						size="sm"
						v-model="filters.serviceEndDate"
					/>
				</b-col>
				<b-col cols="3">
					<b-form-group
						label="Conf. cotizaciones:"
						size="sm"
						>
						<b-form-select v-model="filters.confQuote" class="mb-3" size="sm">
							<b-form-select-option :value="null">Todos</b-form-select-option>
							<b-form-select-option value="withoutPrices">Solo SIN resultados</b-form-select-option>
							<b-form-select-option value="withPrices">Solo CON resultados</b-form-select-option>
						</b-form-select>
					</b-form-group>
				</b-col>
				<b-col cols="3">
					<b-form-group
						label="Iatas:"
						size="sm"
						>
						<b-input v-model="filters.iatas">

						</b-input>
					</b-form-group>
				</b-col>
				<b-col>

					<b-form-group
						label="."
						size="sm"
						>
						<b-button variant="outline-primary" type="button" @click="searchAction()">
							<md-icon icon="search" v-if="!loading"/>
						</b-button>
					</b-form-group>

				</b-col>

			</b-row>

			<section v-if="!loading && !$root.isEmpty(loaded.airports)">
				<BarGraph ref="aptos-chart"> </BarGraph>

					<b-form-group
						class="col-md-4 col-12"
						label="Selecciona un aeropuerto"
					>
					<b-form-select :options="listAirports" v-model="airportSelected"></b-form-select>
				</b-form-group>
				<section v-if="airportSelected !== null" class="mt-5">
					<BarGraph ref="cutoff-chart"> </BarGraph>
					<BarGraph ref="pax-chart" class="mt-3"> </BarGraph>
					<BarGraph ref="service-dates-chart" class="mt-3"> </BarGraph>
				</section>
			</section>
        </b-card>
	</div>
</template>
<script>
import moment from 'moment'
import BarGraph from '../sections/dashboard/charts/templates/BarGraph.vue';
export default {
	props: {
	},
	components: { BarGraph },
	data() {
		let startDate  = moment().subtract(3,"days").format("YYYY-MM-DD");
        let endDate    = moment().subtract(1,"days").format("YYYY-MM-DD");
		return {
			loading: false,
			loadingPercent:0,
			forceStop:false,
			quoteRequests:[],
			airportSelected:null,
			listAirports:[],
			maxDate:endDate,
			filters:{
				module:"resume",
				source:"apiMozio",
				serviceStartDate:null,
				serviceEndDate:null,
				startDate:startDate,
				endDate:endDate,
				confQuote:false,
				withTotal:false,
				iatas:"cun,mbj"
			},
			keySearch:null,
			loaded:{
				airports:[],
				paxPerAirport:[],
				cutoffPerAirport:[],
				serviceDatePerAirport:[]
			}
		};
	},
	computed: {
		totalQuotes() {
			return this.quoteRequests.length;
		},
		filtersComputed(){
			let filters = this.filters;
			return filters;
		},
		dataPaxPerAirport(){
			return [];
		}
	},
	methods: {
		getRange(startDate, endDate, type) {
			if(startDate == endDate) return[moment(startDate)]
			let fromDate = moment(startDate)
			let toDate = moment(endDate)
			let diff = toDate.diff(fromDate, type)
			let range = []
			for (let i = 0; i <= diff; i++) {
				range.push(moment(startDate).add(i, type))
			}
			return range
		},
		async fetch(filters){
			let arrDays  = this.getRange(this.filters.startDate,this.filters.endDate,"days");
			if(arrDays.length>7){
				this.$root.showAlert("Solo se puede consultar maximo 7 dias");
				return;
			}
			this.loading = true;
			let index    = 0;
			let res =[];
			for (const date of arrDays) {
				if(this.forceStop) break;
				let add = {
					searchControl:{
						keySearch:this.keySearch,
						index:index,
						total:arrDays.length
					},
					startDate: date.format("YYYY-MM-DD"),
					endDate: date.format("YYYY-MM-DD")
				}
				filters = {...filters,...add}
				try{
					console.log("start--->"+date.format("YYYY-MM-DD"))
					res = await this.$root.api.post(`/quotes-tool-analisis/quotes`,filters)
					this.loadingPercent = (++index*100)/arrDays.length;
				}catch(err){
					this.$root.showAlert("Ocurrió un error al generar el reporte",{variant:"danger"});
					break;
				}
			}
			this.loading= false;
			this.loadingPercent=0;
			this.forceStop=false;
			this.airportSelected=null;

			if(!this.$root.isEmpty(res.data)){
				this.listAirports =[...["Seleccione una opcion"],...res.data.airports] ;
				this.loaded.paxPerAirport =res.data.paxPerAirport??[];
				this.loaded.cutoffPerAirport=res.data.cutoffPerAirport??[];
				this.loaded.serviceDatePerAirport = res.data.serviceDatePerAirport??[]
				this.loaded.airports = res.data.aptos_with_drilldown??[];
				setTimeout(() => {
					this.applyDataToMainChart();
				}, 0);
			}

		},

		searchAction(){
			this.keySearch= this.generateUUID();
			let filters = {...this.filtersComputed}
			this.fetch(filters)
		},
		generateUUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				const r = Math.random() * 16 | 0;
				const v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
		applyDataToMainChart(){
			let chartOptionsIatas = {
					chart: {
						type: 'column'
					},
					yAxis: {
						min: 0,
						title: {
							text: 'Cotizaciones'
						}
					},
					series:[{
						name:"Aeropuertos [Iatas]",
						data: this.loaded.airports.series
					}],
					drilldown:{series:this.loaded.airports.drilldown}
			}
			this.$refs["aptos-chart"].setChartOptions(chartOptionsIatas);
		},
		applyDataTochartsPerAirport(){

			let seriesPax = [{
				name:"Pax",
				data: this.loaded.paxPerAirport[this.airportSelected]??[],
			}]
			let seriesCutoff = [{
				name:"Days in advance [Cutoff]",
				data: this.loaded.cutoffPerAirport[this.airportSelected]??[],
			}]
			let seriesServiceDates = [{
				name:"Service Date",
				data: this.loaded.serviceDatePerAirport[this.airportSelected]??[],
			}]
			let chartOptions = {
				chart: {
					type: 'column'
				},
				yAxis: {
					min: 0,
					title: {
						text: 'Cotizaciones'
					}
				},
				colors: ['#FF5733', '#3399FF']
			}
			try{
				this.$refs["pax-chart"].setChartOptions({...chartOptions,...{series:seriesPax},...{colors:["#FF5733"]}});
			}catch(err){
				console.log(err)
			}
			try{
				this.$refs["cutoff-chart"].setChartOptions({...chartOptions,...{series:seriesCutoff},...{colors:["#2CF55A"]}});
			}catch(err){
				console.log(err)
			}
			try{
				this.$refs["service-dates-chart"].setChartOptions({...chartOptions,...{series:seriesServiceDates},...{colors:["#4CJ55A"]}});
			}catch(err){
				console.log(err)
			}

		}



	},
	mounted() {
        this.$emit('mounted')
	},
	watch: {
		airportSelected(val){
			setTimeout(() => {
				if(!this.$root.isEmpty(val)){
					console.log("--->"+val)
					this.applyDataTochartsPerAirport()
				}
			}, 0);

		}
	}
};
</script>

<style scoped>

#zones-map {
	width: 100%;
	height: 700px;
}
#zoned-rate-editor .card-body{
    color:black !important
}
</style>

